/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface CalculateAssetRiskScoreRequest {
    id: string;
    sessionId?: string;
}

export interface CalculateVulnerabilityPriorityRequest {
    id: string;
    sessionId?: string;
}

export interface CalculateWeaknessPriorityRequest {
    id: string;
    sessionId?: string;
}

export interface CreateRuleRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface DeleteRuleRequest {
    ruleId: string;
    sessionId?: string;
}

export interface GetByPriorityRequest {
    priorityLevel?: string;
    page?: number;
    size?: number;
    sessionId?: string;
}

export interface GetConfigRequest {
    sessionId?: string;
}

export interface GetRulesRequest {
    entityType?: string;
    sessionId?: string;
}

export interface UpdateConfigRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UpdateRuleRequest {
    ruleId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * RiskPrioritizationApi - interface
 * 
 * @export
 * @interface RiskPrioritizationApiInterface
 */
export interface RiskPrioritizationApiInterface {
    /**
     * Calculates and updates the composite risk score for an asset, combining enhanced impact calculation with associated vulnerabilities and weaknesses.
     * @summary Calculate risk score for an asset
     * @param {string} id Asset ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    calculateAssetRiskScoreRaw(requestParameters: CalculateAssetRiskScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Calculates and updates the composite risk score for an asset, combining enhanced impact calculation with associated vulnerabilities and weaknesses.
     * Calculate risk score for an asset
     */
    calculateAssetRiskScore(requestParameters: CalculateAssetRiskScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Calculates and updates the priority score for a specific vulnerability instance based on CVSS, asset criticality, exploit availability, and enhanced impact factors.
     * @summary Calculate priority for a vulnerability
     * @param {string} id Vulnerability instance ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    calculateVulnerabilityPriorityRaw(requestParameters: CalculateVulnerabilityPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Calculates and updates the priority score for a specific vulnerability instance based on CVSS, asset criticality, exploit availability, and enhanced impact factors.
     * Calculate priority for a vulnerability
     */
    calculateVulnerabilityPriority(requestParameters: CalculateVulnerabilityPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Calculates and updates the priority score for a specific weakness instance based on risk score, asset criticality, and enhanced impact factors.
     * @summary Calculate priority for a weakness
     * @param {string} id Weakness instance ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    calculateWeaknessPriorityRaw(requestParameters: CalculateWeaknessPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Calculates and updates the priority score for a specific weakness instance based on risk score, asset criticality, and enhanced impact factors.
     * Calculate priority for a weakness
     */
    calculateWeaknessPriority(requestParameters: CalculateWeaknessPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Creates a new prioritization rule for the tenant.  Rule structure: {   \"ruleId\": \"priority-rule-001\",   \"name\": \"Critical CVSS on Critical Assets → Priority 95\",   \"description\": \"Automatically set CRITICAL priority for high CVSS on critical assets\",   \"priority\": 10,   \"enabled\": true,   \"entity_type\": \"VULNERABILITY\",   \"rule_type\": \"PRIORITIZATION\",   \"conditions\": [     {\"field\": \"cvss_score\", \"operator\": \"GREATER_THAN_OR_EQUAL\", \"value\": 9.0},     {\"field\": \"asset_criticality\", \"operator\": \"EQUALS\", \"value\": \"CRITICAL\"}   ],   \"actions\": {     \"set_priority_score\": 95.0,     \"override\": true   } } 
     * @summary Create prioritization rule
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    createRuleRaw(requestParameters: CreateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Creates a new prioritization rule for the tenant.  Rule structure: {   \"ruleId\": \"priority-rule-001\",   \"name\": \"Critical CVSS on Critical Assets → Priority 95\",   \"description\": \"Automatically set CRITICAL priority for high CVSS on critical assets\",   \"priority\": 10,   \"enabled\": true,   \"entity_type\": \"VULNERABILITY\",   \"rule_type\": \"PRIORITIZATION\",   \"conditions\": [     {\"field\": \"cvss_score\", \"operator\": \"GREATER_THAN_OR_EQUAL\", \"value\": 9.0},     {\"field\": \"asset_criticality\", \"operator\": \"EQUALS\", \"value\": \"CRITICAL\"}   ],   \"actions\": {     \"set_priority_score\": 95.0,     \"override\": true   } } 
     * Create prioritization rule
     */
    createRule(requestParameters: CreateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Deletes a prioritization rule. Note: This deletes the entire configuration containing the rule. If the configuration contains multiple rules, all rules will be deleted.
     * @summary Delete prioritization rule
     * @param {string} ruleId Rule ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    deleteRuleRaw(requestParameters: DeleteRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Deletes a prioritization rule. Note: This deletes the entire configuration containing the rule. If the configuration contains multiple rules, all rules will be deleted.
     * Delete prioritization rule
     */
    deleteRule(requestParameters: DeleteRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves paginated list of vulnerabilities and weaknesses filtered by priority level (CRITICAL, HIGH, MEDIUM, LOW, UNKNOWN).
     * @summary Get items by priority level
     * @param {string} [priorityLevel] Priority level (CRITICAL, HIGH, MEDIUM, LOW, UNKNOWN)
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [size] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    getByPriorityRaw(requestParameters: GetByPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves paginated list of vulnerabilities and weaknesses filtered by priority level (CRITICAL, HIGH, MEDIUM, LOW, UNKNOWN).
     * Get items by priority level
     */
    getByPriority(requestParameters: GetByPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the prioritization configuration for the tenant, including weights, thresholds, and normalization scores. Returns default configuration if tenant-specific config doesn\'t exist.
     * @summary Get prioritization configuration
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    getConfigRaw(requestParameters: GetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the prioritization configuration for the tenant, including weights, thresholds, and normalization scores. Returns default configuration if tenant-specific config doesn\'t exist.
     * Get prioritization configuration
     */
    getConfig(requestParameters: GetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all prioritization rules for the tenant. Rules are stored in Configuration Service with type PRIORITIZATION_RULE.
     * @summary Get prioritization rules
     * @param {string} [entityType] Entity type filter (VULNERABILITY, WEAKNESS, or null for all)
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    getRulesRaw(requestParameters: GetRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves all prioritization rules for the tenant. Rules are stored in Configuration Service with type PRIORITIZATION_RULE.
     * Get prioritization rules
     */
    getRules(requestParameters: GetRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates the prioritization configuration for the tenant.  Configuration structure: - `impact_weights`: Weights for impact calculation factors (criticality, data_classification, exposure_level, environment, business_impact) - `likelihood_weights`: Weights for likelihood calculation factors (cvss, exploit, threat) - `asset_risk_weights`: Weights for asset risk score calculation (max_vulnerability_priority, enhanced_impact) - `priority_thresholds`: Thresholds for priority level assignment (critical_min, high_min, medium_min) - `criticality_scores`: Normalization scores for asset criticality levels - `data_classification_scores`: Normalization scores for data classification levels - `exposure_level_scores`: Normalization scores for exposure levels - `environment_scores`: Normalization scores for environment types - `exploit_scores`: Normalization scores for exploit maturity levels  Weights are automatically normalized if they don\'t sum to 1.0. 
     * @summary Update prioritization configuration
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    updateConfigRaw(requestParameters: UpdateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates the prioritization configuration for the tenant.  Configuration structure: - `impact_weights`: Weights for impact calculation factors (criticality, data_classification, exposure_level, environment, business_impact) - `likelihood_weights`: Weights for likelihood calculation factors (cvss, exploit, threat) - `asset_risk_weights`: Weights for asset risk score calculation (max_vulnerability_priority, enhanced_impact) - `priority_thresholds`: Thresholds for priority level assignment (critical_min, high_min, medium_min) - `criticality_scores`: Normalization scores for asset criticality levels - `data_classification_scores`: Normalization scores for data classification levels - `exposure_level_scores`: Normalization scores for exposure levels - `environment_scores`: Normalization scores for environment types - `exploit_scores`: Normalization scores for exploit maturity levels  Weights are automatically normalized if they don\'t sum to 1.0. 
     * Update prioritization configuration
     */
    updateConfig(requestParameters: UpdateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates an existing prioritization rule. The ruleId in the path must match the ruleId in the request body.
     * @summary Update prioritization rule
     * @param {string} ruleId Rule ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RiskPrioritizationApiInterface
     */
    updateRuleRaw(requestParameters: UpdateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates an existing prioritization rule. The ruleId in the path must match the ruleId in the request body.
     * Update prioritization rule
     */
    updateRule(requestParameters: UpdateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class RiskPrioritizationApi extends runtime.BaseAPI implements RiskPrioritizationApiInterface {

    /**
     * Calculates and updates the composite risk score for an asset, combining enhanced impact calculation with associated vulnerabilities and weaknesses.
     * Calculate risk score for an asset
     */
    async calculateAssetRiskScoreRaw(requestParameters: CalculateAssetRiskScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling calculateAssetRiskScore().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/risk-prioritization/assets/{id}/calculate-risk-score`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Calculates and updates the composite risk score for an asset, combining enhanced impact calculation with associated vulnerabilities and weaknesses.
     * Calculate risk score for an asset
     */
    async calculateAssetRiskScore(requestParameters: CalculateAssetRiskScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.calculateAssetRiskScoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculates and updates the priority score for a specific vulnerability instance based on CVSS, asset criticality, exploit availability, and enhanced impact factors.
     * Calculate priority for a vulnerability
     */
    async calculateVulnerabilityPriorityRaw(requestParameters: CalculateVulnerabilityPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling calculateVulnerabilityPriority().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/risk-prioritization/vulnerabilities/{id}/calculate-priority`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Calculates and updates the priority score for a specific vulnerability instance based on CVSS, asset criticality, exploit availability, and enhanced impact factors.
     * Calculate priority for a vulnerability
     */
    async calculateVulnerabilityPriority(requestParameters: CalculateVulnerabilityPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.calculateVulnerabilityPriorityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculates and updates the priority score for a specific weakness instance based on risk score, asset criticality, and enhanced impact factors.
     * Calculate priority for a weakness
     */
    async calculateWeaknessPriorityRaw(requestParameters: CalculateWeaknessPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling calculateWeaknessPriority().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/risk-prioritization/weaknesses/{id}/calculate-priority`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Calculates and updates the priority score for a specific weakness instance based on risk score, asset criticality, and enhanced impact factors.
     * Calculate priority for a weakness
     */
    async calculateWeaknessPriority(requestParameters: CalculateWeaknessPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.calculateWeaknessPriorityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new prioritization rule for the tenant.  Rule structure: {   \"ruleId\": \"priority-rule-001\",   \"name\": \"Critical CVSS on Critical Assets → Priority 95\",   \"description\": \"Automatically set CRITICAL priority for high CVSS on critical assets\",   \"priority\": 10,   \"enabled\": true,   \"entity_type\": \"VULNERABILITY\",   \"rule_type\": \"PRIORITIZATION\",   \"conditions\": [     {\"field\": \"cvss_score\", \"operator\": \"GREATER_THAN_OR_EQUAL\", \"value\": 9.0},     {\"field\": \"asset_criticality\", \"operator\": \"EQUALS\", \"value\": \"CRITICAL\"}   ],   \"actions\": {     \"set_priority_score\": 95.0,     \"override\": true   } } 
     * Create prioritization rule
     */
    async createRuleRaw(requestParameters: CreateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/risk-prioritization/rules`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates a new prioritization rule for the tenant.  Rule structure: {   \"ruleId\": \"priority-rule-001\",   \"name\": \"Critical CVSS on Critical Assets → Priority 95\",   \"description\": \"Automatically set CRITICAL priority for high CVSS on critical assets\",   \"priority\": 10,   \"enabled\": true,   \"entity_type\": \"VULNERABILITY\",   \"rule_type\": \"PRIORITIZATION\",   \"conditions\": [     {\"field\": \"cvss_score\", \"operator\": \"GREATER_THAN_OR_EQUAL\", \"value\": 9.0},     {\"field\": \"asset_criticality\", \"operator\": \"EQUALS\", \"value\": \"CRITICAL\"}   ],   \"actions\": {     \"set_priority_score\": 95.0,     \"override\": true   } } 
     * Create prioritization rule
     */
    async createRule(requestParameters: CreateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a prioritization rule. Note: This deletes the entire configuration containing the rule. If the configuration contains multiple rules, all rules will be deleted.
     * Delete prioritization rule
     */
    async deleteRuleRaw(requestParameters: DeleteRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling deleteRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/risk-prioritization/rules/{ruleId}`;
        urlPath = urlPath.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deletes a prioritization rule. Note: This deletes the entire configuration containing the rule. If the configuration contains multiple rules, all rules will be deleted.
     * Delete prioritization rule
     */
    async deleteRule(requestParameters: DeleteRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of vulnerabilities and weaknesses filtered by priority level (CRITICAL, HIGH, MEDIUM, LOW, UNKNOWN).
     * Get items by priority level
     */
    async getByPriorityRaw(requestParameters: GetByPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['priorityLevel'] != null) {
            queryParameters['priorityLevel'] = requestParameters['priorityLevel'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/risk-prioritization/by-priority`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves paginated list of vulnerabilities and weaknesses filtered by priority level (CRITICAL, HIGH, MEDIUM, LOW, UNKNOWN).
     * Get items by priority level
     */
    async getByPriority(requestParameters: GetByPriorityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getByPriorityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the prioritization configuration for the tenant, including weights, thresholds, and normalization scores. Returns default configuration if tenant-specific config doesn\'t exist.
     * Get prioritization configuration
     */
    async getConfigRaw(requestParameters: GetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/risk-prioritization/config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the prioritization configuration for the tenant, including weights, thresholds, and normalization scores. Returns default configuration if tenant-specific config doesn\'t exist.
     * Get prioritization configuration
     */
    async getConfig(requestParameters: GetConfigRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all prioritization rules for the tenant. Rules are stored in Configuration Service with type PRIORITIZATION_RULE.
     * Get prioritization rules
     */
    async getRulesRaw(requestParameters: GetRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/risk-prioritization/rules`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves all prioritization rules for the tenant. Rules are stored in Configuration Service with type PRIORITIZATION_RULE.
     * Get prioritization rules
     */
    async getRules(requestParameters: GetRulesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the prioritization configuration for the tenant.  Configuration structure: - `impact_weights`: Weights for impact calculation factors (criticality, data_classification, exposure_level, environment, business_impact) - `likelihood_weights`: Weights for likelihood calculation factors (cvss, exploit, threat) - `asset_risk_weights`: Weights for asset risk score calculation (max_vulnerability_priority, enhanced_impact) - `priority_thresholds`: Thresholds for priority level assignment (critical_min, high_min, medium_min) - `criticality_scores`: Normalization scores for asset criticality levels - `data_classification_scores`: Normalization scores for data classification levels - `exposure_level_scores`: Normalization scores for exposure levels - `environment_scores`: Normalization scores for environment types - `exploit_scores`: Normalization scores for exploit maturity levels  Weights are automatically normalized if they don\'t sum to 1.0. 
     * Update prioritization configuration
     */
    async updateConfigRaw(requestParameters: UpdateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/risk-prioritization/config`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates the prioritization configuration for the tenant.  Configuration structure: - `impact_weights`: Weights for impact calculation factors (criticality, data_classification, exposure_level, environment, business_impact) - `likelihood_weights`: Weights for likelihood calculation factors (cvss, exploit, threat) - `asset_risk_weights`: Weights for asset risk score calculation (max_vulnerability_priority, enhanced_impact) - `priority_thresholds`: Thresholds for priority level assignment (critical_min, high_min, medium_min) - `criticality_scores`: Normalization scores for asset criticality levels - `data_classification_scores`: Normalization scores for data classification levels - `exposure_level_scores`: Normalization scores for exposure levels - `environment_scores`: Normalization scores for environment types - `exploit_scores`: Normalization scores for exploit maturity levels  Weights are automatically normalized if they don\'t sum to 1.0. 
     * Update prioritization configuration
     */
    async updateConfig(requestParameters: UpdateConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing prioritization rule. The ruleId in the path must match the ruleId in the request body.
     * Update prioritization rule
     */
    async updateRuleRaw(requestParameters: UpdateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling updateRule().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/risk-prioritization/rules/{ruleId}`;
        urlPath = urlPath.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates an existing prioritization rule. The ruleId in the path must match the ruleId in the request body.
     * Update prioritization rule
     */
    async updateRule(requestParameters: UpdateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
